import { ValidationError } from '@mssgme/api-client';

function captureSubmitError(fn) {
    return async (values, helpers) => {
        try {
            await fn(values, helpers);
        } catch (err) {
            if (ValidationError.is(err)) {
                for (let fieldName in err.errors) {
                    helpers.setFieldError(fieldName, err.errors[fieldName]);
                }
            } else {
                throw err;
            }
        }
    };
}

export default captureSubmitError;
